export default {
  "Cut Audio": "Potong Audio",
  "HitPaw Online Audio Cutter": "HitPaw Online Pemotong Audio",
  "Trim or cut any audio files online.": "Pangkas atau potong file audio secara online.",
  "Cut": "Potong",
  "Fade in": "Fade in",
  "Fade out": "Fade out",
  "Cut from": "Potong dari",
  "to": "ke",
  "Extract selection": "Ekstrak pilihan",
  "Delete selection": "Hapus pilihan",
  "Adjust New": "Sesuaikan Baru",
  "Cut New": "Potong Baru",
  "Adjust Volume": "Sesuaikan Volume",
  "HitPaw Online Volume Changer": "HitPaw Online Pengubah Volume",
  "Turn up or Turn down the volume of audio.": "Naikkan atau Kecilkan volume audio.",
  "Volume": "Volume",
  "Change Speed": "Ubah Kecepatan",
  "HitPaw Online Audio Speed Changer": "HitPaw Online Pengubah Kecepatan Audio",
  "Speed up or slow down audios online easily.": "Mempercepat atau memperlambat audio online dengan mudah.",
  "Speed": "Kecepatan",
  "Format": "Format",
  "Size": "Ukuran",
  "Duration": "Durasi",
};
